<div class="progress-container p-4">
    <div class="step-wrapper">
      <div class="step"><img class="active-img bg-orange"  src="assets/img/image_1.png" alt="Step 1"></div>
      <div class="label">File Validation</div>
    </div>
    <div class="line filled"></div>
    <div class="step-wrapper">
      <div class="step"><img class="active-img bg-orange" src="assets/img/image _2 _w.png" alt="Step 2"></div>
      <div class="label">Board Details</div>
    </div>
    <div class="line filled"></div>
    <div class="step-wrapper">
      <div class="step"><img class="active-img bg-orange" src="assets/img/image_3_w.png" alt="Step 3"></div>
      <div class="label">Quote</div>
    </div>
    <div class="line half-filled"></div>
    <div class="step-wrapper">
      <div class="step"><img class="active-img bg-grey" src="assets/img/image_4.png" alt="Step 3"></div>
      <div class="label">Order Details</div>
    </div>
    <div class="line"></div>
    <div class="step-wrapper">
      <div class="step"><img  class="active-img bg-grey" src="assets/img/image_5.png" alt="Step 3"></div>
      <div class="label">Review & Confirm</div>
    </div>
    <div class="line"></div>
    <div class="step-wrapper">
      <div class="step"><img class="active-img bg-grey" src="assets/img/image_6.png" alt="Step 3"></div>
      <div class="label">Place order</div>
    </div>
</div>
<section class=" container">
  <h2 class="text-center header-title page_top_space"> <b>PCB Pricing</b> </h2>
    
  <div class="mt-4" style="display: flex;justify-content: center;">
    <div class="sub-details">
      <div style="margin-right: 80px;">Quote#: <b>{{commonService.commonMainObj.wmqId}}</b></div>
      <div>Part# / Revision: <b>{{commonService.commonMainObj.uploadedFilesData.partNumber}}</b> / <b>{{commonService.commonMainObj.uploadedFilesData.partRevision}}</b></div>
    </div>
  </div>
  <div class="page-heading mt-3 plr-15" >Choose Available Turn Time & Quantity: Fabrication</div>
  <div class="mb-3 plr-15 yellow-txt f-14">PER UNIT PRICES FOR PCBs</div>
  <div class="plr-15 mb-3">
    <table class="table table-bordered"  id="fab-matrix-table" style="text-align: center;">
      <thead>
        <tr>
          <th>Fabrication Turn time<hr style="margin: 5px;">Quantity</th>
          <th class="pad-b25 text-center"  *ngFor="let mat of commonService.commonMainObj.priceMatrixColData; let in = index" >{{commonService.commonMainObj.priceMatrixColData[in].field}}</th>
        </tr>
      </thead>
      <tbody>
        
        <tr *ngFor="let element of commonService.commonMainObj.priceMatrixRowData; let in = index">
          <td class="mat-qty" style="font-weight: bold;">{{commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity}}</td>
            <td class="mat-d" style="text-align: center;" *ngFor="let col of commonService.commonMainObj.priceMatrixColData; let j = index">
              <input *ngIf="commonService.commonMainObj.priceMatrixRowData[in][col.field].split(',')[1] != 1" class="mr-5"  type="radio" name="panel-main-get-quote-pcb-matrix-turnTimeQuantity" id='panel-main-get-quote-pcb-matrix-turnTimeQuantity' value="{{col.field}}" [attr.data-quantity]="commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity" class="mr-5"(click)="checkPrice(col.field,commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity,commonService.commonMainObj.priceMatrixRowData[in][col.field])">
              <label *ngIf="commonService.commonMainObj.priceMatrixRowData[in][col.field].split(',')[1] != 1" class="mat-lable" for="panel-main-get-quote-pcb-matrix-turnTimeQuantity0"  >${{commonService.commonMainObj.priceMatrixRowData[in][col.field].split(',')[0]}}</label>
              <div *ngIf="commonService.commonMainObj.priceMatrixRowData[in][col.field].split(',')[1] == 1" style="font-size: 0.9rem;line-height: 1.2;">
                <div style="font-size: 0.8rem; padding-bottom: 5px;">Not Applicable for Online Quote</div>
                <a *ngIf="col.field != '1 Day' " style="color: #0d6efd;text-decoration: underline; cursor: pointer;" (click)="navigateToCustomeQuote(col.field,commonService.commonMainObj.priceMatrixRowData[in].turnTimeQuantity)">Request for Custom Quote</a>
              </div> 
            </td>
        </tr>
      </tbody>
    </table>
    <div class="mb-3 f-14"><b>TOOLING NRE = $0.00 <span style="color: red;">Free!</span></b></div>
  </div>
  <div class="row" [hidden]="isHidden">
    <div class="col-8">
      <div class="page-heading plr-15" >Choose Available Turn Time & Quantity: Assembly</div>
      <div class="mb-3 plr-15 yellow-txt f-14">PER UNIT PRICES FOR ASSEMBLY LABOR</div>
      <div class="plr-15 mb-3">
        <table class="table table-bordered"  id="assembly-matrix-table" style="text-align: center;">
          <thead>
            <tr>
              <th>Turn time<hr style="margin: 5px;">Quantity</th>
              <th class="pad-b25 text-center"  *ngFor="let mat of commonService.commonMainObj.assemblyMatrixColData; let in = index" >{{commonService.commonMainObj.assemblyMatrixColData[in].field}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of commonService.commonMainObj.assemblyMatrixRowData; let in = index">
              <td class="mat-qty" style="font-weight: bold;">{{commonService.commonMainObj.assemblyMatrixRowData[in].turnTimeQuantity}}</td>
                <td class="mat-d" *ngFor="let col of commonService.commonMainObj.assemblyMatrixColData; let j = index">
                  <input  type="radio" name="panel-main-get-quote-assembly-matrix-turnTimeQuantity" id='panel-main-get-quote-assembly-matrix-turnTimeQuantity' value="{{col.field}}" [attr.data-quantity]="commonService.commonMainObj.assemblyMatrixRowData[in].turnTimeQuantity"(click)="checkAssemblyPrice(col.field,commonService.commonMainObj.assemblyMatrixRowData[in].turnTimeQuantity,commonService.commonMainObj.assemblyMatrixRowData[in][col.field])">
                  <label class="mat-lable" for="panel-main-get-quote-assembly-matrix-turnTimeQuantity0"  >${{commonService.commonMainObj.assemblyMatrixRowData[in][col.field]}}</label>  
                </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="plr-15 fs-14 mb-3" [hidden]="isHidden">
        <p class="fw-b" style="color: red;"><i>Please note with via-in-pad features, total turn time will be minimum 7 days</i></p>
      </div>
      <div class="plr-15 fs-14" >
        <p>Labor charges shown do not include special services such as wire-bonding and conformal coating. These charges also exclude assembly of components that require special fixtures, such as PEM nuts, Turret Terminals and Press-Fit connectors. If any such special services are required they will be quoted separately after your online order is placed.</p>
      </div>
    </div>
    <div class="col-4">
      <div class="fab-info-sec">
        <h3 class="mb-4 text-center" style="font-size: 1.2rem;">CURRENT SELECTIONS</h3>
        <p class="fw-b" style="color: brown;">PCB Fabrication</p>
        <div class="row mb-3">
          <div class="col-7">PART/REV:</div>
          <div class="col-5 text-right">{{commonService.commonMainObj.partNumber}} / {{commonService.commonMainObj.partRevision}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-7">TURNTIME:</div>
          <div class="col-5 text-right">{{commonService.commonMainObj.selectedFabTurntime}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-7">QUANTITY:</div>
          <div class="col-5 text-right">{{commonService.commonMainObj.selectedFabQuantity}}</div>
        </div>
        <div class="row mb-3">
          <div class="col-7">LOT PRICE:</div>
          <div class="col-5 text-right">{{commonService.commonMainObj.lotPrice}}</div>
        </div>
        <div class="row mb-4 fw-b" style="color: brown;">
          <div class="col-7" style="text-align: right;">TOTAL</div>
          <div class="col-5 text-right">{{commonService.commonMainObj.lotPrice}}</div>
        </div>
      </div>
    </div>
  </div>
  
</section>
<!--KIP-1764-->
<section class="container" style="display: none;">
  <div style="display: flex;margin-top: 2rem;">
    <div class="plr-15 get-ass-txt">
      <div class="ofp-tooltip" style="font-weight: normal;">
        <label for="get_assembly_quote" style="font-weight: bold !important;" (mouseover)="showToolTip(1)" (mouseout)="hideToolTip(1)">Get assembly quote?</label>
        <span class="tooltiptext" id="pcbFab-1"></span>
      </div>
    </div>
    <div class="btn-group2" id="get_assembly_quote">
      <input (click)="assemblySwitchOfButtons('assemblyYes', assemblyErrorModal)" type="button" class="btn btn-switch btn-gray " id="assemblyYes" value="Yes"/>
      <input (click)="assemblySwitchOfButtons('assemblyNo', '')" type="button" class="btn btn-switch  btn-green active" id="assemblyNo" value="No" />
    </div>
  </div>
</section>

<section class=" container" id="uploadBomSec" style="display: none;">
  <div class="row m-0 mt-3 mt-5 mb-4">
    <div class="col">
      <div class="page-heading">Assembly Information</div>
      <div class="row">
        <div class="col-sm-3 input-lable text-right">BOM File<span class="required-mark">*</span><br><span style="font-style: italic; font-size: 13px;">(Retrieved from uploaded file)</span></div>
        <div class="col-sm-9">
          <div style="position: relative;" *ngIf="commonService.commonMainObj.fileUploadedData.uploadedBOM">
            <div class="row">
              <div class="col-5">
                <div class="mt-2" *ngIf="commonService.commonMainObj.autoUploadFileName">{{commonService.commonMainObj.autoUploadFileName}} </div>
                <div class="mt-2" *ngIf="!commonService.commonMainObj.autoUploadFileName">{{commonService.commonMainObj.uploadedFile?.name}} </div>
              </div>
              <div class="col-7" style="display: inline-flex;">
                <div><span class="not-bom-text">Not the BOM you wanted?</span></div>
                <div><button class="btn btn-warning fs14 me-2" (click)="uploadOtherBom()" title="{{commonService.commonMainObj.autoUploadFileName || commonService.commonMainObj.uploadedFile?.name}}"><b>Upload a Different BOM</b></button><br/><span style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
                <div class="ion-text-left fs15 mt5 pl5">
                  <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" download style="position: relative;left: -20px;">Download custom BOM format</a>
                </div>
                </div>
              </div>
            </div>
            <input type="file" id="fileInputOther" #fileInputOther style="display: none" accept=".xls,.xlsx"
          (change)="fileBrowseHandler($event)"/>
          </div>
          <div *ngIf="!commonService.commonMainObj.fileUploadedData.uploadedBOM" class="mt-2 mb-1 file-input-container form-control customize-input file-input" >
            <div class="styled-input" style="display: flex;cursor:pointer;" (click)="fileInput.click()">
              <div class="choose-file" >Choose file</div>
              <div class="upload-name" title="{{  curentAssemblyFileUploadedName }}">{{  curentAssemblyFileUploadedName || 'No file chosen' }}
              </div>
            </div>
            <input type="file" #fileInput style="display: none" accept=".xls,.xlsx" (change)="fileBrowseHandler($event)"/>
          </div>
          <span *ngIf="!commonService.commonMainObj.fileUploadedData.uploadedBOM" style="color: green; font-style: italic; font-size: 13px; font-weight: bold;">(Accepted formats: .xls, .xlsx)</span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-3 input-lable text-right">
          <div class="ofp-tooltip">
            <label for="assemblySidesNumber" (mouseover)="showToolTip(2)" (mouseout)="hideToolTip(2)">Number of sides to be assembled</label>
            <span class="tooltiptext" id="pcbFab-2"></span>
          </div>
        </div>
        <div class="col-9 btn-group2" id="assemblySidesNumber">
          <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch btn-green active " id="numberOfSidesOne" value="One side"/>
          <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch btn-gray " id="numberOfSidesTwo" value="Two sides"/>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-3 input-lable text-right">
          <div class="ofp-tooltip">
            <label for="lead_free_processing" (mouseover)="showToolTip(3)" (mouseout)="hideToolTip(3)">Lead-free processing</label>
            <span class="tooltiptext" id="pcbFab-3"></span>
          </div>
        </div>
        <div class="col-9 btn-group2" id="lead_free_processing">
          <div class="ofp-tooltip">
            <div (mouseover)="showToolTip(1)" (mouseout)="hideToolTip(1)">
            <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch btn-gray " id="leadFreeYes" value="Yes" /></div>
            <span class="tooltiptext" id="leadFreeProcess-1"></span>
          </div>
          <div class="ofp-tooltip">
            <div (mouseover)="showToolTip(2)" (mouseout)="hideToolTip(2)">
            <input (click)="switchOfButtons($event,'')" type="button" class="btn btn-switch  btn-green active" id="LeadFreeNo" value="No"  disabled/></div>
            <span class="tooltiptext" id="leadFreeProcess-2"></span>
          </div>
        </div>
      </div>
      <div class="row mt-3"  *ngIf="commonService.commonMainObj.pcbType == 'Web PCB'">
        <div class="col-sm-3 input-lable text-right">PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" href="{{apiService.Via_In_Pad_URL}}" target="_blank">Via-in-pad</a> features?</div>
        <div class="col-sm-9" id="viaInPads">
          <div class="ofp-tooltip">
            <input type="button" class="btn btn-switch btn-gray" id="viaInPadsYes" value="Yes" (click)="switchOfButtons($event,'')"/>
            <span class="tooltiptext" id="viaInPadInfo">You have chosen a PCB fabrication time of {{selectedFabTurntimeVal}} days.
              In order to <span style="color: green;">fill your via-in-pads with non-conductive fill,</span> we will need PCB fabrication cycle of 5 days or more.
              Kindly choose a turn time for 5 days or more in the PCB price matrix above.
              </span>
          </div>
          <input type="button" class="btn btn-switch btn-green active" id="viaInPadsNo" value="No" (click)="switchOfButtons($event,'')"/>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-3 input-lable text-right">
          <div class="ofp-tooltip">
            <label for="assembly_quantity" (mouseover)="showToolTip(4)" (mouseout)="hideToolTip(4)">Quantity of assembled boards<span class="required-mark">*</span></label>
            <span class="tooltiptext" id="pcbFab-4"></span>
          </div>
        </div>
        <div class="col-sm-9">
          <input type="text" id="assembly_quantity" [(ngModel)]="commonService.commonMainObj.qtyAssemblies" class="form-control customize-input" disabled readOnly="true"/>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="container mb-4 mt-4">
  <div class="text-center">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="backToBoardDetails()"><b>Back</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="commonService.goBack()"><b>Cancel</b></button>
    <button id="quote-proceed-btn" type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="bomProceed(autoMapping)"><b>Proceed</b></button>
  </div>
</section>

<ng-template #autoMapping let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">BOM column mapping</h4>
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="showNumberOfSheets">
    <div class="row m-0 mt-2 mb-3">
      <div class="col">
        <div class="text-center mb-3"><b><u>Map the column headings for your BOM</u></b></div>
        <div class="text-center fs14 text-danger"> <b>Note: </b> Please select the column name for the mandatory columns that are not auto-mapped. If any of the mandatory columns are not present in the BOM, click on "Cancel" button and upload a new BOM that has all the mandatory columns.</div>
      </div>
    </div>
    <!-- Changes done based on OFP-652 -->
    <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
      <div class="row justify-content-md-center" *ngFor="let cma of mainRowArrayObj['labelsArray'];let idx = index" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
        <div class="row justify-content-md-center"  *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">
          <div class="col-sm-3">
            <div>
              <label *ngIf="cma.labelType != 'new'">{{cma.labelName}}<span class="text-danger" *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">*</span></label>
            </div>
          </div>
          
          <div class="col-sm-4">
              <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" [ngClass]="cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number' ? 'requiredField' : 'notRequireField'" placeholder="Select" [(ngModel)]="cma.selectedName1" (change)="checkIfAllOptionsPresent()">
                <option value="">Select</option>
                <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj" *ngFor="let crow of mainRowArrayObj['bomOneMapArrayData']">
                  {{crow.labelValue}}
                </option>
              </select>
          </div>
        </div>
      </div>
    </div>

    <div [hidden]="mainRowArrayObj['labelsArray'].length == 0">
      <div class="row justify-content-md-center" *ngFor="let cma of mainRowArrayObj['labelsArray'];let idx = index" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
        <div class="row justify-content-md-center"  *ngIf="!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">
          <div class="col-sm-3">
            <div>
              <label *ngIf="cma.labelType != 'new'">{{cma.labelName}}<span class="text-danger" *ngIf="(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')">*</span></label>
            </div>
          </div>
          
          <div class="col-sm-4">
              <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" placeholder="Select" [(ngModel)]="cma.selectedName1">
                <option value="">Select</option>
                <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj" *ngFor="let crow of mainRowArrayObj['bomOneMapArrayData']">
                  {{crow.labelValue}}
                </option>
              </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body" *ngIf="!showNumberOfSheets">
    <div class="row m-0 mt-2 mb-3">
      <div class="col">
        <div class="text-center clr_green mb-5"><b>Your excel has multiple worksheets. Please specify worksheet that has BOM info.</b></div>
        <div class="row justify-content-md-center">
          <div class="col-sm-3">
              <label>Select Sheet: </label>
          </div>
          <div class="col-sm-4">
              <select class="form-control form-select mb-3" placeholder="Select" [(ngModel)]="selectedSheetNum">
                <option value="">Select</option>
                <option value="{{sheet.index}}" *ngFor="let sheet of sheetsArray">
                  {{sheet.name}}
                </option>
              </select>
            </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;" *ngIf="!showNumberOfSheets">
    <button type="button" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5 m-3" (click)="proceedSheet()"><b>Proceed</b></button>
  </div>
  <div class="modal-footer text-center" style="display: block;" *ngIf="showNumberOfSheets">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn_blue_custom btn-warning px-xxl-5 m-3" id="automap-modal-proceed-btn" (click)="proceedAutoMapData()" ><b>Proceed</b></button>
    <!-- (click)="modal.close('Save click')" [disabled]="disableAutomapProceed == true" OFP-613 -->
  </div>
</ng-template>
<ng-template #via_in_pad let-modal class="address-book-modal">
  <div class="modal-header">
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button>
  </div>
  <div class="modal-body">
      <iframe id="via_in_pad_frame" src="https://www.protoexpress.com/customer-portal/via-in-pad-features.jsp&embedded=true"  ></iframe>
  </div>
</ng-template>
<ng-template #assemblyErrorModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Assembly File Errors</h4>
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="text-center text-danger">Please fix the following errors to get assembly quote.</div>
    <div>
      <div class="brd_warning">
        <div class="table-row">
        <table class="table warning-table mt-4" style="width: 100%; word-break: break-word;">
          <thead>
            <tr>
              <th style="width: 30%;text-align:center; background-color:#fcb816;">Error</th>
              <th style="width: 30%;text-align:center; background-color:#fcb816;">Additional Information</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let assmblyErr of commonService.commonMainObj.uploadedFilesData?.fileAsmblyErrors; index as idx">
              <td style="width: 50%;vertical-align: top;">
                <div style="font-size: 1rem;color:#e37403;font-weight: 500;">{{assmblyErr.error}}</div>
                <div class="text-right">
                  <label for="{{assmblyErr.errorCode}}" class="missing-file-lable">
                    <input type="file" class="missing-file-input" id="{{assmblyErr.errorCode}}" (change)="missingFilesHandel($event, ''+assmblyErr.errorCode)">
                    <i class="fa fa-cloud-upload"></i> Upload
                  </label>
                </div>
                <div>
                  <span id="{{assmblyErr.errorCode}}_name" class="file-color"></span>
                  <span style="display: none;" class="delete-file fa-del fa fa-solid fa-trash" id="{{assmblyErr.errorCode}}_delete" (click)="deleteFile(''+assmblyErr.errorCode)"></span>
                </div>
                <span id="{{assmblyErr.errorCode}}_error" class="error-message"></span>
              </td>
              <td style="width: 50%; color: #59544f;">{{assmblyErr.description}}</td>
              
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3 " id="assembly_error_proceed" [disabled]="disableAssemblyErrorProceed == true" (click)="reValidate()"><b>Proceed</b></button>
  </div>
</ng-template>
<app-footer></app-footer>